import { Component } from '@angular/core';

@Component({
  selector: 'app-smartch',
  templateUrl: './smartch.component.html',
  styleUrls: ['./smartch.component.css']
})
export class SmartchComponent {
  gbr_a: string = "assets/img/bg/sail.svg";
  gbr_b: string = "assets/img/bg/destination.svg";
  gbr_c: string = "assets/img/bg/wallet.svg";
  gbr_d: string = "assets/img/bg/documentation.svg";
}
